export * from '@fhs/routing/src/routes/v2/offers/all/index';
export { default } from '@fhs/routing/src/routes/v2/offers/all/index';
